import {withLazyDynamicTable} from "../../ui/hoc/LazyDynamicTable";
import React from "react";
import {searchOrganizations} from "../../../api/organization-functions";
import {OrganizationsTable} from "./OrganizationsTable";


export const OrganizationsTableConnected = (props: any) => {
    const query = ({page, size, filter}: any) => {
        return searchOrganizations(filter, size,  page * size);
    };

    return withLazyDynamicTable(OrganizationsTable, query, [])({...props});
};
